import { render, staticRenderFns } from "./appointmentDetail.vue?vue&type=template&id=48480635&scoped=true&"
import script from "./appointmentDetail.vue?vue&type=script&lang=js&"
export * from "./appointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDetail.vue?vue&type=style&index=0&id=48480635&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48480635",
  null
  
)

export default component.exports